// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"601b19f5","327":"d7aee8c1","343":"0b3fb703","462":"7c486aa4","595":"f946d2ab","633":"a1224cf7","794":"c94b4228","873":"b6fdaf2b"}[chunkId] + ".chunk.js";
};